module.exports = __webpack_public_path__ + "img/113.2.35585f02.png";